import CustomTable from "../common/CustomTable";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { attendanceEmpModalIdState, modalTitle } from "../../utils/atoms/atoms";
import { AttendanceMonthColumns } from "../../utils/table/attendanceCols";
import React from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getAttdMonthById } from "../../api/attendance";
import { useEffect } from "react";
import { isAttendanceSunday } from "../../utils/funcs/time";

interface IAttendanceMonthModalBody {
  empCode: number;
}

const AttendanceMonthModalBody = ({ empCode }: IAttendanceMonthModalBody) => {
  const queryClient = useQueryClient();
  const attendanceEmpModalId = useRecoilValue(attendanceEmpModalIdState);
  const setModalTitle = useSetRecoilState(modalTitle);
  const {
    isLoading,
    data: attendanceMonth,
    isSuccess,
  } = useQuery({
    queryKey: ["attendance_id_month", attendanceEmpModalId],
    queryFn: () => getAttdMonthById(attendanceEmpModalId),
  });

  const attdEmpMonthMutation = useMutation({
    mutationFn: async (empId) => {
      return getAttdMonthById(empId);
    },
    onSuccess: (data) => {
      queryClient.setQueryData(["attendance_id_month"], data);
      if (data.attendance[0]?.emp_name) {
        setModalTitle(data.attendance[0].emp_name);
      } else {
        setModalTitle("Data not found");
      }
    },
  });

  useEffect(() => {
    if (attendanceEmpModalId === empCode) {
      attdEmpMonthMutation.mutate(attendanceEmpModalId);
    }
  }, [attendanceEmpModalId]);

  return (
    <React.Fragment>
      {isLoading ? (
        "Loading"
      ) : isSuccess ? (
        <CustomTable
          data={attendanceMonth?.attendance}
          columns={AttendanceMonthColumns}
          rowClassName={(row) =>
            isAttendanceSunday(row.curr_date) ? "attendance-row--sunday" : ""
          }
        />
      ) : (
        "Something went wrong"
      )}
    </React.Fragment>
  );
};

export default AttendanceMonthModalBody;
